module.exports = __webpack_public_path__ + "img/logout_border.b59be1c6.svg";